module.exports = __webpack_public_path__ + "media/images/www/windows_social-9f2d978c52e740dcad36ff105f9fec5a.jpg";